import { Shield, ExternalLink, MessageSquare, Brain, Sparkles } from 'lucide-react';
import PresaleWidget from '../components/PresaleWidget';
import { useState, useEffect } from 'react';
import AITerminal from '../components/AITerminal';

export default function Home() {
  const [showTerminal, setShowTerminal] = useState(false);
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowBanner(scrollPosition < 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center overflow-hidden">
             {/* Airdrop Live Banner */}
       {showBanner && (
         <a 
           href="#airdrop"
           className="fixed top-16 left-0 right-0 bg-gradient-to-r from-quantum-primary/20 via-quantum-secondary/20 to-quantum-primary/20 border-y border-quantum-primary/50 backdrop-blur-sm z-50 cursor-pointer hover:from-quantum-primary/25 hover:via-quantum-secondary/25 hover:to-quantum-primary/25 transition-all duration-300"
         >
         <div className="text-center py-4">
           <span className="text-quantum-primary font-bold text-lg animate-pulse drop-shadow-lg">
             ✨ QUANTUM GENESIS AIRDROP IS LIVE! ✨
           </span>
           <div className="text-quantum-light font-semibold text-sm mt-2 animate-pulse drop-shadow-md">
             Join @QgenairdropBot now to claim your share of 30M QGEN tokens!
           </div>
                  </div>
       </a>
       )}

       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-12 md:pt-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <img 
              src="/media/qg-main-banner.webp" 
              alt="Quantum Genesis" 
              className="w-full h-auto mb-6 rounded-lg mt-24 md:mt-0"
            />
            <h1 className="font-tokyo text-3xl md:text-4xl lg:text-5xl text-center mb-4 bg-gradient-to-r from-quantum-primary to-quantum-secondary bg-clip-text text-transparent">
              Quantum Genesis: The Meme Coin That Fights the Future
            </h1>
            <p className="text-lg md:text-xl text-quantum-light/80 text-center mb-8 max-w-2xl mx-auto leading-relaxed">
              Quantum Genesis is the only crypto brave enough to take on quantum computers. Hold $QGEN and stand with the chain's last line of defense — before the future breaks the blockchain.
            </p>
            
            <div className="flex flex-col gap-8 lg:hidden">
              <div className="flex justify-center gap-6 items-center">
                <a 
                  href="https://x.com/QgenToken"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="quantum-button !bg-black/90 backdrop-blur-sm flex items-center justify-center w-10 h-10 !p-0 hover:scale-110 transition-transform duration-300 hover:shadow-lg hover:shadow-quantum-primary/20"
                >
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
                <a 
                  href="https://t.me/QuantumGenesisHQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="quantum-button !bg-[#229ED9]/90 backdrop-blur-sm flex items-center justify-center w-10 h-10 !p-0 hover:scale-110 transition-transform duration-300 hover:shadow-lg hover:shadow-quantum-primary/20"
                >
                  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                  </svg>
                </a>
                <a 
                  href="https://t.me/QgenTokenAnn"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="quantum-button !bg-[#229ED9]/90 backdrop-blur-sm flex items-center justify-center w-10 h-10 !p-0 hover:scale-110 transition-transform duration-300 hover:shadow-lg hover:shadow-quantum-primary/20"
                >
                  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                  </svg>
                </a>
                <a
                  href="https://app.solidproof.io/projects/quantum-genesis"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img 
                    src="/media/solid.svg" 
                    alt="Audited by SolidProof" 
                    className="h-10 w-auto object-contain"
                  />
                </a>
                
                {/* AI Agent Button (Mobile) */}
                <button
                  onClick={() => setShowTerminal(true)}
                  className="quantum-button !bg-quantum-primary/90 backdrop-blur-sm flex items-center justify-center px-4 hover:scale-110 transition-transform duration-300 hover:shadow-lg hover:shadow-quantum-primary/20"
                >
                  <span>AI Agent</span>
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-8">
            <PresaleWidget />
            <div className="hidden lg:flex justify-center gap-6 items-center">
              <a 
                href="https://x.com/QgenToken"
                target="_blank"
                rel="noopener noreferrer"
                className="quantum-button !bg-black/90 backdrop-blur-sm flex items-center justify-center w-10 h-10 !p-0 hover:scale-110 transition-transform duration-300 hover:shadow-lg hover:shadow-quantum-primary/20"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a 
                href="https://t.me/QuantumGenesisHQ"
                target="_blank"
                rel="noopener noreferrer"
                className="quantum-button !bg-[#229ED9]/90 backdrop-blur-sm flex items-center justify-center w-10 h-10 !p-0 hover:scale-110 transition-transform duration-300 hover:shadow-lg hover:shadow-quantum-primary/20"
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                </svg>
              </a>
              <a 
                href="https://t.me/QgenTokenAnn"
                target="_blank"
                rel="noopener noreferrer"
                className="quantum-button !bg-[#229ED9]/90 backdrop-blur-sm flex items-center justify-center w-10 h-10 !p-0 hover:scale-110 transition-transform duration-300 hover:shadow-lg hover:shadow-quantum-primary/20"
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                </svg>
              </a>
              <a
                href="https://app.solidproof.io/projects/quantum-genesis"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/media/solid.svg"
                  alt="Audited by SolidProof"
                  className="h-10 w-auto object-contain"
                />
              </a>
              
              {/* AI Agent Button */}
              <button
                onClick={() => setShowTerminal(true)}
                className="quantum-button !bg-quantum-primary/90 backdrop-blur-sm flex items-center justify-center gap-2 px-4 hover:scale-105 transition-transform duration-300 hover:shadow-lg hover:shadow-quantum-primary/20"
              >
                <Sparkles className="w-5 h-5" />
                <span>AI Agent</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* AI Terminal Component */}
      <AITerminal isOpen={showTerminal} onClose={() => setShowTerminal(false)} />
    </div>
  );
}
